<section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div class="row no-gutters slider-text align-items-center justify-content-center">

        </div>
    </div>
</section>

<section class="ftco-section bg-light">
    <div class="container">
        <div class="row no-gutters justify-content-center">
            <div class="col-md-12">
                <div class="wrapper">
                    <div class="row d-flex justify-content-center g-0">
                        <div class="col-lg-6">
                            <div class="contact-wrap w-100 wrap-content">
                                <h3>
                                    Forgot Password
                                </h3>
                                <p class="mb-1">Please enter your email address below. We will send you a link to reset your password to that email address.</p>
                                <form *ngIf="!isSuccess" id="forgotPasswordForm" [formGroup]="forgotPasswordForm" name="forgotPasswordForm"
                                    class="contactForm" method="POST">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input type="email" class="form-control" name="email" id="email"
                                                    placeholder="Email" formControlName="email"
                                                    [class.is-invalid]="forgotPasswordForm.get('email')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Email ID is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <button type="button" (click)="onSubmit()" id="submit"
                                                        class="btn btn-primary">Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div *ngIf="isSubmitted && isSuccess" class="alert alert-success mt-3" role="alert">
                                    <p class="success-message">Check your email for the reset password link and follow the instructions to regain access to your account.</p>
                                </div>
                                <!-- <div class="w-100 social-media mt-5">
                                    <h3>
                                        Follow us here
                                    </h3>
                                    <p>
                                        <a href="#">Facebook</a>
                                        <a href="#">Twitter</a>
                                        <a href="#">Instagram</a>
                                        <a href="#">Dribbble</a>
                                    </p>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
